// Pages/Login.js
import { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import { toast } from "react-toastify";
import axios from "../api/api";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post("/api/admin/login", {
        email,
        password,
      });
      const { token, user } = response.data;
      // Call the login function from AuthContext to store token and user
      login(token, user);

      toast.success("Login successful!");

      navigate("/contact");
    } catch (err) {
      toast.error(err.response?.data?.error || "Login failed");
    }
  };

  return (
    <div className="relative flex flex-col justify-center min-h-screen overflow-hidden">
      <div className="w-full m-auto bg-white dark:bg-slate-800/60 rounded shadow-lg ring-2 ring-slate-300/50 dark:ring-slate-700/50 lg:max-w-md">
        <div className="text-center p-6 bg-slate-900 rounded-t">
          <a href="/">
            <img
              src="/images/logo-sm.png"
              alt=""
              className="w-14 h-14 mx-auto mb-2"
            />
          </a>
          <h3 className="font-semibold text-white text-xl mb-1">
            Let's Get Started Excellent
          </h3>
          <p className="text-xs text-slate-400">
            Sign in to continue to Excellent.
          </p>
        </div>
        <form className="p-6" onSubmit={handleSubmit}>
          <div>
            <label
              htmlFor="email"
              className="font-medium text-sm text-slate-600 dark:text-slate-400"
            >
              Email
            </label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="form-input w-full rounded-md mt-1 border border-slate-300/60 dark:border-slate-700 dark:text-slate-300 bg-transparent px-3 py-2 focus:outline-none focus:ring-0 placeholder:text-slate-400/70 placeholder:font-normal placeholder:text-sm hover:border-slate-400 focus:border-primary-500 dark:focus:border-primary-500 dark:hover:border-slate-700"
              placeholder="Your Email"
              required
            />
          </div>
          <div className="mt-4">
            <label
              htmlFor="password"
              className="font-medium text-sm text-slate-600 dark:text-slate-400"
            >
              Your password
            </label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="form-input w-full rounded-md mt-1 border border-slate-300/60 dark:border-slate-700 dark:text-slate-300 bg-transparent px-3 py-2 focus:outline-none focus:ring-0 placeholder:text-slate-400/70 placeholder:font-normal placeholder:text-sm hover:border-slate-400 focus:border-primary-500 dark:focus:border-primary-500 dark:hover:border-slate-700"
              placeholder="Password"
              required
            />
          </div>
          <div className="block mt-3">
            <label className="custom-label block dark:text-slate-300">
              <div className="bg-white dark:bg-slate-700 border border-slate-200 dark:border-slate-600 rounded w-4 h-4 inline-block leading-4 text-center -mb-[3px]">
                <input type="checkbox" className="hidden" />
                <i className="fas fa-check hidden text-xs text-slate-700 dark:text-slate-200" />
              </div>
               &nbsp;Remember me
            </label>
          </div>
          <div className="mt-4">
            <button
              type="submit"
              className="w-full px-2 py-2 tracking-wide text-white transition-colors duration-200 transform bg-brand-500 rounded hover:bg-brand-600 focus:outline-none focus:bg-brand-600"
            >
              Login
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
